module.exports = React;


//////////////////
// WEBPACK FOOTER
// external "React"
// module id = 0
// module chunks = 0 1 2 3 4 9 10 11 12 13 14 15 16 17 18 19 20 37 38